import React, { useState } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import styled from 'styled-components'
import { SingleDatePicker } from 'react-dates'
import colors from '../../../configuration/colors'
import { postLevelTargetDate } from '../../../actions/courses'
import { NewCloseIcon } from './_Styled'
import IconTargetDateCalendar from '../../../static/images/icons/icon_level_target_date_calendar.svg'
import useLexicon from '../../../hooks/useLexicon'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-right: 2px;
  padding: 0 0 4px;
  background: ${`10px 40% rgba(255,255,255,0.7) url(${IconTargetDateCalendar}) no-repeat`};
  border-radius: 7px;
  z-index: 2;

  .DateInput_input,
  .DateInput_input__focused {
    padding: 0;
    margin-bottom: 1px;
    background: transparent;
    height: auto;
    cursor: pointer;
    color: ${colors.dove};
    font-size: 14px;
    font-weight: 400;
  }

  .SingleDatePickerInput__showClearDate {
    padding-right: 0;
  }

  .SingleDatePickerInput__withBorder_2 {
    border: none;
  }

  .SingleDatePickerInput {
    background: transparent;
    cursor: pointer;
    padding-left: 35px;

    .DateInput {
      width: 170px;
      height: auto;
      border-radius: 5px;
      background: transparent;
    }
  }

  .SingleDatePickerInput_clearDate {
    margin: 0;
    outline: 0;
  }

  .SingleDatePickerInput,
  .DateInput_input {
    border-radius: 5px;
  }

  .DateInput_input::placeholder {
    color: ${colors.dove};
    font-size: 13px;
    font-weight: 300 !important;
  }

  .CalendarDay__default:hover {
    color: ${colors.black};
  }

  .CalendarDay__selected:hover {
    color: ${colors.white};
  }
`

const SetTargetDateNew = ({
  dispatch,
  levelId,
  courseSectionId,
  targetDate
}) => {
  const [date, setDate] = useState(targetDate)
  const [focused, setFocused] = useState(false)
  const lexicon = useLexicon()

  return (
    <Wrapper>
      <SingleDatePicker
        id="setStartDate"
        placeholder={`Set ${lexicon.level} Target Date`}
        date={date ? moment(date) : null}
        numberOfMonths={2}
        hideKeyboardShortcutsPanel
        readOnly
        showClearDate
        focused={focused}
        onDateChange={date => {
          setDate(date)
          dispatch(
            postLevelTargetDate(
              courseSectionId,
              levelId,
              date ? date.format('YYYY-MM-DD') : null
            )
          )
        }}
        displayFormat={() =>
          moment(date).isSame(moment(), 'day')
            ? '[Today,] D MMMM YYYY'
            : 'D MMMM YYYY'
        }
        onFocusChange={({ focused }) => {
          setFocused(focused)
        }}
        customCloseIcon={<NewCloseIcon />}
      />
    </Wrapper>
  )
}

SetTargetDateNew.propTypes = {
  dispatch: PropTypes.func,
  levelId: PropTypes.number.isRequired,
  courseSectionId: PropTypes.number.isRequired,
  targetDate: PropTypes.string
}

export default SetTargetDateNew
